var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "fill-height",
      "width": "600",
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.uploadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.deleteMediaStatus
    }
  }), _c('sign-in-dialog', {
    ref: "sign-in",
    scopedSlots: _vm._u([{
      key: "subtitle",
      fn: function () {
        return [_vm._v("Please sign in to upload custom media")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload",
    attrs: {
      "type": "file",
      "accept": "audio/*"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('v-card', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex align-center pa-3"
  }, [_c('div', {
    staticClass: "title pl-1"
  }, [_vm._v("Music")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0 mr-2",
    attrs: {
      "hide-details": "",
      "input-value": _vm.isActive
    },
    nativeOn: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isActive && _vm.$emit('input', null);
      }
    }
  }), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Done")])], 1), _c('v-divider'), _c('div', {
    staticClass: "d-flex justify-center align-center text-center pa-3",
    staticStyle: {
      "height": "88px"
    }
  }, [_vm.selected ? _c('audio-preview-btn', {
    staticClass: "flex-shrink-1 overflow-hidden",
    attrs: {
      "color": "primary",
      "dark": "",
      "name": _vm.stripUUID(_vm.selected.name),
      "src": _vm.value
    }
  }) : _c('div', {
    staticClass: "d-flex align-center font-italic grey--text"
  }, [_vm._v("No music selected")])], 1), _c('v-divider'), _c('div', {
    staticClass: "pa-2 pb-0 d-flex"
  }, [!_vm.noCustomMedia ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "loading": _vm.promptUploadStatus.pending || _vm.uploadStatus.pending
    },
    on: {
      "click": _vm.promptUpload
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  }), _c('span', {
    staticClass: "text-body-2",
    staticStyle: {
      "text-transform": "none",
      "font-weight": "normal"
    }
  }, [_vm._v("Upload your own"), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v(" music")]), _vm._v("…")])], 1) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "warning",
      "disabled": !_vm.value
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', null);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMusicOff)
    }
  }), _c('span', {
    staticClass: "text-body-2",
    staticStyle: {
      "text-transform": "none",
      "font-weight": "normal"
    }
  }, [_vm._v("Remove")])], 1)], 1), _c('v-row', {
    staticClass: "flex-grow-0 ma-0 px-2 py-1"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "5",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tags,
      "menu-props": {
        maxHeight: '400'
      },
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Genres / Moods"
    },
    model: {
      value: _vm.selectedTag,
      callback: function ($$v) {
        _vm.selectedTag = $$v;
      },
      expression: "selectedTag"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "7",
      "sm": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": "Search"
    },
    model: {
      value: _vm.filter,
      callback: function ($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 1)], 1), _vm.loadDefaultLibraryStatus.pending || _vm.loadUserLibraryStatus.pending ? [_c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }), _c('v-spacer')] : _c('v-virtual-scroll', {
    staticClass: "flex-grow-1",
    attrs: {
      "items": _vm.filtered,
      "item-height": 52
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-list-item', {
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "px-3",
          attrs: {
            "input-value": _vm.value == item.url
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('input', _vm.value == item.url ? null : item.url);
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": "",
            "color": "primary"
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.value == item.url ? _vm.mdiCheckboxMarked : _vm.mdiCheckboxBlankOutline)
          }
        })], 1), _c('div', {
          staticClass: "ma-2 btn-group"
        }, [_c('audio-preview-btn', {
          class: {
            'btn-group-right': !item.tags
          },
          attrs: {
            "color": _vm.value == item.url ? 'primary' : null,
            "name": _vm.stripUUID(item.name),
            "src": item.url
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
            }
          }
        }), !item.tags ? _c('v-btn', {
          staticClass: "btn-group-left",
          attrs: {
            "rounded": "",
            "color": _vm.value == item.url ? 'primary' : null,
            "loading": _vm.deleting === item
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.deleteMedia(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "warning"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiDelete)
          }
        })], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }